<template>
    <!-- 个人预存转团队预存 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
        <div>为保障您的资金安全，我们将给您的手机号：{{ userInfo.phoneNumber || '-' }}发送短信验证码，已验证身份</div>
        <el-form ref="form" :model="form" label-width="0" style="margin-top: 20px" label-position="left">
            <el-row type="flex" style="flex-wrap: wrap" :gutter="30">
                <el-col :span="20">
                    <el-form-item prop="invoiceTitle">
                        <div style="display: flex">
                            <el-input v-model="form.code" placeholder="请输入获取的验证码" style="width: 60%"></el-input>
                            <el-button class="codeClass" v-show="show" @click="sendCode">获取短信验证码</el-button>
                            <el-button style="float: right; width: 35%" v-show="!show" :disabled="isdisabled">{{ count }}S</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="footer_btn">
            <el-button type="primary" size="small" style="width: 80px" plain @click="close">取消</el-button>
            <el-button type="primary" size="small" style="width: 80px" @click="openPop" v-preventClick>确认</el-button>
        </div>
        <el-dialog append-to-body title="个人预存转团队预存" :visible.sync="submitPop" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" :model="form" label-width="180px">
                <el-form-item label="个人预存余额:">
                    <div>¥ {{ userInfo.depositAdvance || '0.00' }}</div>
                </el-form-item>
                <el-form-item label="团队预存余额:">
                    <div>¥ {{ teamInfo.depositAdvance || '0.00' }}</div>
                </el-form-item>
                <el-form-item label="转到团队预存的余额:" prop="convertMoney">
                    <el-input v-model="form.convertMoney" type="number" show-word-limit placeholder="请输入金额"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="footer_btn">
                <el-button type="primary" size="small" style="width: 80px" plain @click="close">取消</el-button>
                <el-button type="primary" size="small" style="width: 80px" @click="submitHandle()" v-preventClick>确认</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
import { sendPrestoreVerifyCode, clientCeconvertToTeamPrestorertApply, teamInfo } from '@/api/request';
import { getClient } from '@/plugins/auth';
export default {
    components: {},
    data() {
        return {
            dialogVisible: true,
            submitPop: false,
            title: '',
            userInfo: JSON.parse(getClient()),
            form: {
                code: '',
                clientId: '',
                teamId: '',
                convertMoney: 0
            },
            show: true,
            teamInfo: {},
            isdisabled: false,
            registerVisible: false,
            activeIndex: 1,
            count: ''
        };
    },
    mounted() {
        teamInfo(this.userInfo.teamId).then((res) => {
            this.teamInfo = res.data;
        });
    },
    methods: {
        init() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                teamInfo(this.userInfo.teamId).then((res) => {
                    this.teamInfo = res.data;
                });
                this.userInfo.enPhoneNumber = this.encryptionPhoneNumber(this.userInfo.phoneNumber);
            });
        },
        //获取验证码
        sendCode() {
            sendPrestoreVerifyCode({ phoneNumber: this.userInfo.phoneNumber }).then((res) => {
                if (res.code == 200) {
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.isdisabled = false;
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000);
                    }
                }
            });
        },
        openPop() {
            this.submitPop = true;
        },

        //确认结果
        submitHandle() {
            this.form.clientId = this.userInfo.clientId;
            this.form.teamId = this.userInfo.teamId;
            clientCeconvertToTeamPrestorertApply(this.form).then((res) => {
                this.$message.success('您已将个人预存转入团队预存');
                this.close();
            });
        },
        close() {
            this.submitHandle = false;
            this.dialogVisible = false;
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
.footer_btn {
    width: 100%;
    display: flex;
    justify-content: center;
}
.codeClass {
    float: right;
    width: 35%;
    border: 1px solid #4486e8;
    color: #4d6fff;
    margin-left: 20px;
}
</style>
